import { CDN } from "src/services/config";

export const url = {
  auth: "/auth",
  systemAccessControl: "/system/access-controls",
  systemEmployee: "/system/employee",
  systemDepartment: "/system/department",
  systemPermission: "/system/permissions",
  systemRole: "/system/role",
  systemRefresh: "/system/_re_fresh",
  sharedResource: "/system/shared",
  cacheAction: "/cache/current-action",
  cacheUser: "/cache/current-user",
  flfCategory: "/flf/flf-categories",
  flfDevice: "/flf/flf-devices",
  flfIcon: "/flf/flf-device-icon",
  flfCustomer: "/flf/flf-customer",
  flfIotPartner: "/flf/flf-iot-partner",
  flfPairingType: "/flf/flf-pairing-type",
  flfRogoDevType: "/flf/flf-rogo-dev-type",
  flfRogoDevSubType: "/flf/flf-rogo-dev-sub-type",
  flfQueryType: "/flf/flf-query-type",
  flfNotifyConfig: "/flf/flf-notify-config",
  flfContext: "/flf/flf-context",
  flfHomeIndex: "/flf/flf-home-index",
  profileDevice: "/profile-device",
  cmsDevice: "/cms/devices",
  cmsIotCalling: "/cms/iot-calling",
  cmsIotCallingCampaign: "/cms/iot-calling-campaign",
  adb: "/cms/adb",
  adbDistrict: "/cms/adb/district",
  adbProvince: "/cms/adb/province",
  adbWard: "/cms/adb/ward",
  releaseGroup: "/ota/release-group",
  releaseAppOS: "/ota/release-app-os",
  releaseTypeSpeaker: "/ota/release-type-speaker",
  releaseAppVersion: "/ota/release-app-version",
  releaseSpeakerVersion: "/ota/release-speaker-version",
  ttsIntent: "/tts/intent",
  ttsEvent: "/tts/event",
  ttsSkill: "/tts/skill",
  ttsContext: "/tts/context",
  ttsSlot: "/tts/slot",
  ttsValue: "/tts/value",
  ttsIntentScript: "/tts/intent-script",
  ttsColor: "/tts/color",
  dmParentPlatform: "/platform/display-platform-parent",
  dmPlatform: "/platform/display-platform",
  dmDisplayGroup: "/platform/display-group",
  dmDisplayDevice: "/platform/display-device",
};

export const path = {
  systemAccessControl: "/systems/access-controls",
  systemEmployee: "/systems/employees",
  systemDepartment: "/systems/departments",
  systemPermission: "/systems/permissions",
  systemRole: "/systems/roles",
  systemRefresh: "/systems/_re_freshes",
  flfCategory: "/fpt-life/categories",
  flfDevice: "/fpt-life/device",
  flfIcon: "/fpt-life/icons",
  flfIotPartner: "/fpt-life/iot-partner",
  flfPairingType: "/fpt-life/pairing-type",
  flfCustomer: "/fpt-life/customer",
  flfContext: "/fpt-life/context",
  flfRogoDevType: "/fpt-life/rogo-dev-type",
  flfRogoDevSubType: "/fpt-life/rogo-dev-sub-type",
  flfQueryType: "/fpt-life/query-type",
  flfNotifyConfig: "/fpt-life/notify-config",
  flfHomeIndex: "/fpt-life/home-index",
  cmsDevice: "/cms/device",
  cmsAdb: "/cms/administrative",
  cmsIotCalling: "/cms/iot-calling",
  cmsIotCallingCampaign: "/cms/iot-calling-campaign",
  releaseGroup: "/ota/release-group",
  releaseOperatingSystem: "/ota/release-os",
  releaseTypeSpeaker: "/ota/release-type-speaker",
  releaseAppVersion: "/ota/release-app-version",
  releaseSpeakerVersion: "/ota/release-speaker-version",
  ttsIntent: "/tts/intents",
  ttsSkill: "/tts/skills",
  ttsEvent: "/tts/events",
  ttsContext: "/tts/contexts",
  ttsSlot: "/tts/slots",
  ttsColor: "/tts/colors",
  dmParentPlatform: "/display-management/parent-platform",
  dmPlatform: "/display-management/platform",
  dmGroup: "/display-management/display-group",
};

export const URL_CDN = CDN;
